// Modo de operación del backoffice: 'retail' (default) | 'cafeteria'.
// Cambia qué muestra el sidebar (retail completo vs. solo cafetería). Persistente.
const KEY = 'appMode';

export function getAppMode() {
    return localStorage.getItem(KEY) === 'cafeteria' ? 'cafeteria' : 'retail';
}

export function setAppMode(mode) {
    localStorage.setItem(KEY, mode === 'cafeteria' ? 'cafeteria' : 'retail');
}

export function isCafeteriaMode() {
    return getAppMode() === 'cafeteria';
}
